/** @jsx jsx */
/** @jsxFrag null */
import {Bar} from 'common/charts/visualization/bar-viz/types';

// cannot have negative values with a stacked bar
export function isBarValid(bar: Bar, hasNegativeValues: boolean) {
  if (bar.segments.length > 1) {
    if (hasNegativeValues) {
      return false;
    }

    if (bar.segments.some((segment) => segment.value < 0)) {
      return false;
    }
  }

  return true;
}
